import { PropsWithChildren } from 'react';

import { Heading } from '@betterment/samba-react';

type StepHeadingProps = {
  isCentered?: boolean;
};

const StepHeading: React.FC<PropsWithChildren<StepHeadingProps>> = ({ children, isCentered }) => {
  return (
    <Heading
      css={{
        textAlign: isCentered ? 'center' : 'left',
        fontSize: {
          lgDown: '28px',
          mdDown: 'fontSize.300',
        },
        textWrap: 'wrap',
        lineHeight: 'lineHeight.300',
      }}
    >
      {children}
    </Heading>
  );
};

export default StepHeading;
